import {useMemo} from 'react'

import {filterConversationItems} from './utils/filter-items'
import {buildReviewThreadItems} from './utils/build-conversation-items'

import {useDiffPathOrderMap, useThreads} from '../../stores/layout-selectors'
import {sortConversationItemsByDate, sortThreadItemsByDiffOrder} from './utils/sort-items'
import type {UseFilteredCommentsDataOptions} from './use-filtered-conversation-items'

/** Fetch and calculate filtered review thread items. */
export function useFilteredReviewThreadItems({filterState, sort}: UseFilteredCommentsDataOptions) {
  const threadPreviews = useThreads()

  const diffPathOrderMap = useDiffPathOrderMap()

  // Review thread mode displays threads as flat list without issue comments or review summaries
  const reviewThreadItems = useMemo(() => {
    const unfilteredItems = buildReviewThreadItems(threadPreviews)
    const filteredItems = filterConversationItems(unfilteredItems, filterState)
    const filteredSortedItems =
      sort === 'diff-order'
        ? sortThreadItemsByDiffOrder(filteredItems, diffPathOrderMap)
        : sortConversationItemsByDate(filteredItems, sort)

    return {unfilteredItems, filteredSortedItems}
  }, [filterState, threadPreviews, diffPathOrderMap, sort])

  return {
    /** Thread items matching the conversation filter and sort direction. */
    filteredConversationItems: reviewThreadItems.filteredSortedItems,
    /** Total number of threads in this PR. */
    totalConversationItemsCount: reviewThreadItems.unfilteredItems.length,
  }
}
